const queryString = require('query-string');

function initLanguageSelect (e) {
  const search = queryString.parse(window.location.search);
  const $select = $(e.target);
  search.locale = $select.val();
  window.location.search = `?${queryString.stringify(search)}`;
}

function attachLanguageSelectContext () {
  $(document).on('change', '.opt-select--language-select select, .viz-select--language select, .viz-select--language-footer select', initLanguageSelect);
}

export default attachLanguageSelectContext;
